module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[39]38.b9ff6a5.woff2";